var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyNavIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/filled/videocam"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15133_112607",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 44,
    height: 44,
    fill: "#97A5A9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15133_112607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "videocam",
    d: "M7.83366 36.6654C6.82533 36.6654 5.96213 36.3063 5.24408 35.5883C4.52602 34.8702 4.16699 34.007 4.16699 32.9987V10.9987C4.16699 9.99036 4.52602 9.12717 5.24408 8.40911C5.96213 7.69106 6.82533 7.33203 7.83366 7.33203H29.8337C30.842 7.33203 31.7052 7.69106 32.4232 8.40911C33.1413 9.12717 33.5003 9.99036 33.5003 10.9987V19.2487L40.8337 11.9154V32.082L33.5003 24.7487V32.9987C33.5003 34.007 33.1413 34.8702 32.4232 35.5883C31.7052 36.3063 30.842 36.6654 29.8337 36.6654H7.83366Z",
    fill: "#97A5A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyNavIcon);
export default __webpack_public_path__ + "static/media/Body_Nav_Icon.df25d1a3e89d583aa58aa12c3725086b.svg";
export { ForwardRef as ReactComponent };